// 轻量提示音：用 Web Audio 合成，无需托管音频文件、规避跨域与自动播放素材问题。
// 发送音（playSend）与到达音（playReceive）音色不同，便于区分。

let _ctx: AudioContext | null = null;
let _enabled = true;

function audioCtx(): AudioContext | null {
  try {
    if (!_ctx) {
      const AC = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (!AC) return null;
      _ctx = new AC();
    }
    // 访客已与 widget 交互过（点开/发送），多数情况下允许；被挂起则尝试恢复
    if (_ctx && _ctx.state === "suspended") { _ctx.resume().catch(function () {}); }
    return _ctx;
  } catch (e) { return null; }
}

function tone(freq: number, peak: number, durationMs: number, type: OscillatorType, delayMs: number): void {
  const ac = audioCtx();
  if (!ac) return;
  const start = ac.currentTime + delayMs / 1000;
  const end = start + durationMs / 1000;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, end);
  osc.connect(gain);
  gain.connect(ac.destination);
  osc.start(start);
  osc.stop(end + 0.02);
}

/** 允许宿主关闭提示音（预留） */
export function setSoundEnabled(on: boolean): void { _enabled = on; }

/** 发送消息：单声短促上扬 */
export function playSend(): void {
  if (!_enabled) return;
  tone(620, 0.05, 70, "triangle", 0);
}

/** 收到消息（AI/客服）：柔和双音 */
export function playReceive(): void {
  if (!_enabled) return;
  tone(523.25, 0.06, 110, "sine", 0);   // C5
  tone(783.99, 0.05, 130, "sine", 90);  // G5
}
